import React from 'react'
import SlickSlider from 'react-slick'
import PropTypes from 'prop-types'
import ImgCover from '../utilities/img-cover'

const InnerSlider = props => {
  const settings = {
    arrows: false,
    slidesToShow: 1,
    className: 'inner-slider',
    dots: true
  }
  const totalSlides = props.slides.map((item, i) => (
    <div className='slide ' key={i}>
      <ImgCover src={item} />
    </div>
  ))
  return (
    <div className='inner-slider-container'>
      {props.slides.length > 0 && (
        <SlickSlider {...settings}>{totalSlides}</SlickSlider>
      )}
    </div>
  )
}

InnerSlider.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.string)
}
InnerSlider.defaultProps = {
  slides: []
}

export default InnerSlider



// WEBPACK FOOTER //
// ./src/ui/sliders/inner-slider.js